module.exports = __webpack_public_path__ + "img/brand_introduction.9a420a6e.png";